import { t } from '@/locales/index';

export const OrderStatus = Object.freeze({
	New: 'New',
	Draft: 'Draft',
	InPreparation: 'In_Preparation',
	ReadyForShipping: 'Ready_For_Shipping',
	PartialShipped: 'Partial_Shipped',
	Shipped: 'Shipped',
	Cancelled: 'Cancelled',
	Rejected: 'Rejected',
	Delivered: 'Delivered',
	InProgressReturn: 'In_Progress_Return',
	Returned: 'Returned',
	PartialReturned: 'Partial_Returned',
});

export const OrderStatusBadgeColor = Object.freeze({
	[OrderStatus.New]: 'gray',
	[OrderStatus.Draft]: 'gray',
	[OrderStatus.InPreparation]: 'warning',
	[OrderStatus.ReadyForShipping]: 'brand',
	[OrderStatus.PartialShipped]: 'blue',
	[OrderStatus.Shipped]: 'blue',
	[OrderStatus.Cancelled]: 'error',
	[OrderStatus.Rejected]: 'error',
	[OrderStatus.Delivered]: 'success',
	[OrderStatus.InProgressReturn]: 'indigo',
	[OrderStatus.Returned]: 'success',
	[OrderStatus.PartialReturned]: 'indigo',
});

export const PaymentStatus = Object.freeze({
	Paid: 'Paid',
	Valid: 'Valid',
	Expired: 'Expired',
	Generate: 'Generate',
});

export const InvoiceStatus = Object.freeze({
	success: 'Paid',
	pending: 'pending',
	expired: 'Expired',
});

export const OrderStatusBadgeVariant = Object.freeze({
	[OrderStatus.New]: 'gray',
	[OrderStatus.Draft]: 'gray',
	[OrderStatus.InPreparation]: 'brand',
	[OrderStatus.ReadyForShipping]: 'brand',
	[OrderStatus.PartialShipped]: 'blue',
	[OrderStatus.Shipped]: 'blue',
	[OrderStatus.Cancelled]: 'warning',
	[OrderStatus.Rejected]: 'error',
	[OrderStatus.Delivered]: 'success',
	[OrderStatus.InProgressReturn]: 'indigo',
	[OrderStatus.Returned]: 'success',
	[OrderStatus.PartialReturned]: 'indigo',
});

export const FinancialStatusesEnum = Object.freeze({
	Paid: 'paid',
	Unpaid: 'unpaid',
	Refunded: 'refunded',
	Pending: 'pending',
	PartiallyPaid: 'partially_paid',
	Voided: 'voided',
	PartiallyRefunded: 'partially_refunded',
});

export const financialStatusesOptions = Object.values(FinancialStatusesEnum).map((status) => ({
	id: status,
	label: t(`orders.financial-status-enum.${status}`),
}));
